import type { IHierarchyKeyObjectives } from '../model/modalTypes'

import { getSingleRootExpansionKeys } from './getSingleRootExpansionKeys'

type TExpansionItem = Pick<IHierarchyKeyObjectives, 'key' | 'parent' | 'HasChildren'>

export const getKeyObjectiveExpansionKeys = (
  items: readonly TExpansionItem[],
  expandToLeaves: boolean,
  selectedKey?: string
): string[] => {
  if (!selectedKey) return getSingleRootExpansionKeys(items, expandToLeaves)

  // Use the full hierarchy: the dropdown excludes the selected item from its visible rows.
  const itemsByKey = new Map(items.map((item) => [item.key, item]))
  let item = itemsByKey.get(selectedKey)
  if (!item) return []

  const ancestors: string[] = []
  const visited = new Set([selectedKey])
  while (item.parent !== undefined && item.parent !== null) {
    const parent = itemsByKey.get(item.parent)
    if (!parent || visited.has(parent.key)) return []

    visited.add(parent.key)
    ancestors.push(parent.key)
    item = parent
  }

  return ancestors.reverse()
}
